import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mg-menu-link-wrapper"
};
const _hoisted_2 = {
  class: "mg-menu-link-prefix"
};
const _hoisted_3 = ["title"];
const _hoisted_4 = {
  class: "mg-menu-link-suffix"
};
const _hoisted_5 = {
  class: "mg-menu-link-shortcut"
};
import MgSubMenu from './mg-sub-menu.vue';
import { computed, ref } from 'vue';
export default {
  __name: 'mg-menu-item',
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    shortcut: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    children: {
      type: Array
    },
    popAlign: {
      type: String,
      default: 'right'
    }
  },
  emits: ['hover', 'item-hover', 'item-click', 'click'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const isHover = ref(false);
    const children = computed(() => props.children || []);
    const hasChildren = computed(() => {
      return !!children && Array.isArray(children.value) && children.value.length > 0;
    });
    const handleMouseenter = e => {
      e.stopPropagation();
      isHover.value = true;
      emit('hover', {
        isHover: true,
        $event: e
      });
    };
    const handleMouseleave = e => {
      e.stopPropagation();
      isHover.value = false;
      emit('hover', {
        isHover: false,
        $event: e
      });
    };
    const handleClick = e => {
      if (!hasChildren.value) {
        emit('click', e);
      }
    };
    const handleItemClick = ({
      item,
      $event
    }) => {
      emit('item-click', {
        $event,
        item
      });
    };
    const handleItemHover = options => {
      const {
        isHover: hover,
        item,
        $event
      } = options;
      isHover.value = hover;
      emit('item-hover', {
        isHover: hover,
        item,
        $event
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass(['mg-menu-item-wrapper', {
          'is--disabled': __props.disabled
        }, {
          'is--hover': isHover.value
        }]),
        onMouseenter: handleMouseenter,
        onMouseleave: handleMouseleave,
        onClick: handleClick
      }, [_createElementVNode("a", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "icon", {}, () => [_createElementVNode("i", {
        class: _normalizeClass(__props.icon)
      }, null, 2)])]), _createElementVNode("div", {
        class: "mg-menu-link-content",
        title: __props.title
      }, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(__props.title), 1)])], 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_renderSlot(_ctx.$slots, "shortcut", {}, () => [_createTextVNode(_toDisplayString(__props.shortcut), 1)])]), _createElementVNode("i", {
        class: _normalizeClass(['mg-menu-link-icon', {
          'vxe-icon-arrow-right': hasChildren.value
        }, {
          'vxe-icon-check': !hasChildren.value && __props.checked
        }])
      }, null, 2)])]), hasChildren.value ? (_openBlock(), _createBlock(MgSubMenu, {
        key: 0,
        items: children.value,
        open: isHover.value,
        "pop-align": __props.popAlign,
        onItemClick: handleItemClick,
        onItemHover: handleItemHover
      }, null, 8, ["items", "open", "pop-align"])) : _createCommentVNode("", true)], 34);
    };
  }
};